import { Check } from 'lucide-react';

// Combined trust positioning: seeded RNG (mathematical audit) + independent
// witness (procedural audit). Both facts, no exaggeration in either direction.
// See T&Cs clause 8 for the full description.
const DEFAULT = [
  'Cryptographically seeded draw',
  'Independently witnessed',
  'Verify it yourself',
  'Draw goes ahead regardless of sales',
];

export const TrustStrip = ({ items = DEFAULT }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 bg-[color:var(--pd-bg)] border border-pd rounded-2xl p-4" data-testid="trust-signals-strip">
    {items.map((t) => (
      <div key={t} className="flex items-start gap-2">
        <Check size={16} className="text-[color:var(--pd-accent-yellow)] mt-1 shrink-0" />
        <span className="text-sm text-[color:var(--pd-text)]">{t}</span>
      </div>
    ))}
  </div>
);

export default TrustStrip;
